import type { HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

/** Loading placeholder. Shimmer stops under prefers-reduced-motion. */
export function Skeleton({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div aria-hidden className={cn("skeleton h-4", className)} {...rest} />;
}
